import spinner from "../../assets/media/logos/fiducia/fd-isotipo-color.svg"
export default function LoaderC() {
    return (
        <div className="d-flex flex-column py-3">
            <img alt="Logo" className=" h-45px" src={spinner}/>
            <div className="d-flex justify-content-center align-items-center mt-1">
                <span className="spinner-border text-primary" role="status"></span>
                <span className="text-muted fs-6 fw-semibold ms-5">Cargando...</span>
            </div>
        </div>
    );
}
